module.exports = __webpack_public_path__ + "static/media/catalog-2.e912faf2.png";